import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { MusicGenre } from '@/core/api/entities/musicGenre/musicGenre'
import { MusicGenreMapper } from '@/core/api/mappers/musicGenre/musicGenreMapper'
import musicGenreService from '@/core/api/services/musicGenreService'

export function useMusicGenres({ config, options }: any = {}): UseQueryResult<
	MusicGenre[],
	Error
> {
	const QUERY_KEY = [
		'music_genres',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			musicGenreService.getMusicGenres(config).then(({ data }) => {
				return MusicGenreMapper.toEntities(data.data)
			}),
		...options,
		cacheTime: 86400000, // 24h
		staleTime: 86400000, // 24h
	})
}
